import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardMainContainer from '../common/Containers/DashboardMainContainer';
import { AdminPanelTitle, AdminMetric, AdminMainText } from '../../sections/AdminDashboard/shared/adminUx';
import { AdminWidgetHeader } from './AdminWidgetChrome';

const PendingTasksWidget = ({ className = 'masonry-item w-[400px] h-[400px] flex flex-col' }) => {
  const navigate = useNavigate();

  const taskData = {
    totalPending: 12,
    profileCompletion: 70,
    tasks: [
      { name: 'Business Details', completed: true, icon: 'camera', path: '#' },
      { name: 'Media Upload', completed: true, icon: 'phone', path: '#' },
      { name: 'Business Contact', completed: false, icon: 'link', path: '/business-dashboard/settings/account' },
      { name: 'Business Hours', completed: false, icon: 'clock', path: '/business-dashboard/settings/account' },
      { name: 'Social Media', completed: false, icon: 'building', path: '/business-dashboard/settings/account' },
    ],
  };

  const handleTaskClick = (path) => {
    navigate(path);
  };

  return (
    <DashboardMainContainer className={className}>
      <AdminWidgetHeader title="Account & Profile" />

      <div className="flex-1 p-4 space-y-4">
        <div className="flex items-center justify-between">
          <div className="text-left">
            <AdminMetric size="large" className="text-offblack tabular-nums block">
              {taskData.totalPending}
            </AdminMetric>
            <AdminPanelTitle className="text-offblack">Pending</AdminPanelTitle>
          </div>

          <div className="flex flex-col items-end">
            <AdminMetric size="medium" className="mb-2 tabular-nums">
              {taskData.profileCompletion}%
            </AdminMetric>
            <div className="w-48 h-2 bg-lightgray rounded-full">
              <div
                className="h-2 bg-primaryblue rounded-full transition-all duration-300"
                style={{ width: `${taskData.profileCompletion}%` }}
              />
            </div>
            <AdminPanelTitle className="text-offblack mt-1">Profile completion</AdminPanelTitle>
          </div>
        </div>

        <div className="border-t border-lightgray" />

        <div className="space-y-2">
          {taskData.tasks.map((task, index) => (
            <div
              key={index}
              role="button"
              tabIndex={0}
              className="flex items-center gap-2 py-2 px-3 cursor-pointer transition-colors rounded-lg border border-lightgray"
              onClick={() => handleTaskClick(task.path)}
              onKeyDown={(e) => e.key === 'Enter' && handleTaskClick(task.path)}
            >
              <div className="flex-shrink-0">
                {task.completed ? (
                  <div className="w-5 h-5 bg-primaryblue rounded-full flex items-center justify-center">
                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                ) : (
                  <div className="w-5 h-5 border-2 border-mediumgray rounded-full" />
                )}
              </div>

              <AdminMainText className="flex-1 text-offblack">{task.name}</AdminMainText>

              <div className="flex-shrink-0">
                <svg className="w-4 h-4 text-mediumgray" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default PendingTasksWidget;
